import React, { PropsWithChildren, useContext, useState } from 'react';

interface PanelViewProps {
  defaultView?: string;
}

export type PanelViewContext = {
  activePanel: string;
  setActivePanel: (panel: string) => void;
};

const PanelViewContext = React.createContext<PanelViewContext | undefined>(
  undefined
);

export const PanelViewProvider = ({
  children,
  defaultView = '',
}: PropsWithChildren<PanelViewProps>) => {
  const [activePanel, setActivePanel] = useState<string>(defaultView);

  return (
    <PanelViewContext.Provider value={{ activePanel, setActivePanel }}>
      {children}
    </PanelViewContext.Provider>
  );
};

export const usePanelView = () => {
  const context = useContext(PanelViewContext);

  if (context === undefined)
    throw new Error('usePanelView must be used within a PanelViewProvider');

  return context;
};

export const PanelView = ({
  id,
  children,
}: PropsWithChildren<{ id: string }>) => {
  const { activePanel } = usePanelView();

  if (activePanel !== id) return null;
  return <React.Fragment>{children}</React.Fragment>;
};
